import type { TemplateIdAttributes } from './meetingSignalTypes.ts';

/**
 * Template ID fragments for Confluence meeting templates.
 *
 * A template matches when its ID contains one of these fragments. The check ignores letter case.
 * Sprint Review is not in the list because Confluence has no matching template ID.
 */
const MEETING_TEMPLATE_KEY_FRAGMENTS: readonly string[] = [
	'meeting-notes', // Meeting notes
	'recurring-meeting-minutes', // Weekly meeting notes
	'1-on-1-meeting', // 1-on-1 Meeting
	'daily-stand-up', // Daily stand up
	'sprint-planning-meeting', // Sprint planning meeting
	'retrospective', // Retrospective + 4 Ls Retrospective
	'project-kickoff', // Project Kickoff
	'projectplan', // Project plan
];

/** Returns true when the template ID matches a Confluence meeting template. */
export const matchesMeetingTemplate = (
	template: TemplateIdAttributes | null | undefined,
): boolean => {
	const id = template?.id;
	if (!id) {
		return false;
	}
	const normalised = id.toLowerCase();
	return MEETING_TEMPLATE_KEY_FRAGMENTS.some((fragment) => normalised.includes(fragment));
};
